class DatabaseThickPlateASTM_A20 {
    constructor() {
        this.nominalThickness = [
            "ASTM_A20", 4.76, 6.35, 7.94, 9.53, 11.11, 12.7, 14.29, 15.88, 19.05, 22.23, 25.4, 28.58, 31.75, 38.1, 44.45, 50.8,
            "ABNT_EB35", 5.3, 5.6, 6, 6.3, 6.7, 7.1, 7.5, 8, 8.5, 9, 9.5, 10, 10.6, 11.2, 11.8, 12.5, 13.2, 14, 15, 16, 17, 18, 19, 20, 21.2, 22.4, 23.6, 25, 26.5, 28, 30, 31.5, 33.5, 35.5, 37.5, 40, 42.5, 45, 47.5, 50, 53, 56, 60, 63, 67, 71, 75, 80, 85, 90, 95, 100
        ];
    }
}

export default DatabaseThickPlateASTM_A20;